import { combineReducers } from 'redux';
import { combineActions, handleActions } from 'redux-actions';
import * as actionTypes from './info-constants';

export const data = handleActions(
  {
    [actionTypes.GET_EQUIPMENT_INFO_REQUEST]: () => ({}),
    [combineActions(
      actionTypes.GET_EQUIPMENT_INFO_SUCCESS,
      actionTypes.SAVE_EQUIPMENT_INFO_SUCCESS,
    )]: (state, { payload }) => payload.details.equipment,
  },
  {},
);

export const lock = handleActions(
  {
    [actionTypes.GET_EQUIPMENT_INFO_REQUEST]: () => null,
    [combineActions(
      actionTypes.GET_EQUIPMENT_INFO_SUCCESS,
      actionTypes.SAVE_EQUIPMENT_INFO_SUCCESS,
      actionTypes.SAVE_EQUIPMENT_INFO_FAILURE,
    )]: (state, { payload }) => payload.lock || null,
  },
  null,
);

export const lockingErrorType = handleActions(
  {
    [actionTypes.GET_EQUIPMENT_INFO_REQUEST]: () => null,
    [combineActions(
      actionTypes.GET_EQUIPMENT_INFO_SUCCESS,
      actionTypes.SAVE_EQUIPMENT_INFO_SUCCESS,
    )]: (state, { payload }) => payload.lockingErrorType,
  },
  null,
);

export const partners = handleActions(
  {
    [actionTypes.GET_EQUIPMENT_INFO_REQUEST]: () => [],
    [actionTypes.GET_EQUIPMENT_INFO_SUCCESS]: (state, { payload }) => {
      const linkedPartners = payload.details.equipment.partners;
      if (!linkedPartners || !payload.partners) {
        return state;
      }
      const partnerIds = linkedPartners?.map(p => p.number);
      return payload.partners?.filter(p => partnerIds.includes(p.number));
    },
  },
  [],
);

export const userStatuses = handleActions(
  {
    [actionTypes.GET_EQUIPMENT_INFO_REQUEST]: () => [],
    [actionTypes.GET_EQUIPMENT_INFO_SUCCESS]: (state, { payload }) => payload.userStatuses,
  },
  [],
);

export const taskLists = handleActions(
  {
    LOCATION_CHANGE: () => [],
    [actionTypes.GET_EQUIPMENT_INFO_REQUEST]: () => [],
    [actionTypes.GET_EQUIPMENT_INFO_SUCCESS]: (state, { payload }) => payload.taskLists,
  },
  [],
);

export const visitTypes = handleActions(
  {
    [actionTypes.GET_EQUIPMENT_INFO_REQUEST]: () => [],
    LOCATION_CHANGE: () => [],
    [actionTypes.GET_EQUIPMENT_INFO_SUCCESS]: (state, { payload }) =>
      payload &&
      payload.taskLists &&
      payload.taskLists?.map(t => ({
        id: t.id,
        // eslint-disable-next-line max-len
        text: `${!t.isActive ? 'INACTIVE - ' : ''}${t.group.replace(/^0+/, '')}/${t.groupCounter} - ${t.description}${t.usage ? ` - ${t.usage}` : ''}`,
      })),
  },
  [],
);

export const isLoading = handleActions(
  {
    [actionTypes.GET_EQUIPMENT_INFO_REQUEST]: () => true,
    [combineActions(
      actionTypes.GET_EQUIPMENT_INFO_SUCCESS,
      actionTypes.GET_EQUIPMENT_INFO_FAILURE,
      actionTypes.SAVE_EQUIPMENT_INFO_REQUEST,
      actionTypes.SAVE_EQUIPMENT_INFO_SUCCESS,
    )]: () => false,
  },
  false,
);

export const error = handleActions(
  {
    [combineActions(
      'LOCATION_CHANGE',
      actionTypes.GET_EQUIPMENT_INFO_REQUEST,
      actionTypes.GET_EQUIPMENT_INFO_SUCCESS,
      actionTypes.SAVE_EQUIPMENT_INFO_REQUEST,
      actionTypes.SAVE_EQUIPMENT_INFO_SUCCESS,
    )]: () => ({}),
    [combineActions(
      actionTypes.GET_EQUIPMENT_INFO_FAILURE,
      actionTypes.SAVE_EQUIPMENT_INFO_FAILURE,
    )]: (state, { payload }) => payload.error,
  },
  {},
);

export const isSaving = handleActions(
  {
    [combineActions(
      actionTypes.SAVE_EQUIPMENT_INFO_REQUEST,
    )]: () => true,
    [combineActions(
      actionTypes.SAVE_EQUIPMENT_INFO_SUCCESS,
      actionTypes.SAVE_EQUIPMENT_INFO_FAILURE,
    )]: () => false,
  },
  false,
);

export const saveSuccess = handleActions(
  {
    [actionTypes.SAVE_EQUIPMENT_INFO_SUCCESS]: () => true,
    [combineActions(
      actionTypes.SAVE_EQUIPMENT_INFO_REQUEST,
      actionTypes.SAVE_EQUIPMENT_INFO_FAILURE,
      actionTypes.RESET_SAVE_SUCCESS,
    )]: () => false,
  },
  false,
);

export const lockingErrors = handleActions(
  {
    [actionTypes.GET_EQUIPMENT_INFO_REQUEST]: () => [],
    [combineActions(
      actionTypes.GET_EQUIPMENT_INFO_SUCCESS,
      actionTypes.SAVE_EQUIPMENT_INFO_SUCCESS,
    )]: (state, { payload }) => payload.lockingErrors || [],
  },
  [],
);

export const connectionStatus = handleActions(
  {
    [actionTypes.CONNECTION_STATUS_SUCCESS]: (state, { payload }) => payload,
    [combineActions(
      actionTypes.CONNECTION_STATUS_FAILURE,
      actionTypes.CONNECTION_STATUS_REQUEST,
    )]: () => null,
  },
  null,
);

export const connectionStatusLoading = handleActions(
  {
    [actionTypes.CONNECTION_STATUS_REQUEST]: () => true,
    [combineActions(
      actionTypes.CONNECTION_STATUS_SUCCESS,
      actionTypes.CONNECTION_STATUS_FAILURE,
    )]: () => false,
  },
  false,
);

export const connectionStatusError = handleActions(
  {
    [actionTypes.CONNECTION_STATUS_FAILURE]: () => true,
    [combineActions(
      actionTypes.CONNECTION_STATUS_SUCCESS,
      'LOCATION_CHANGE',
      actionTypes.CONNECTION_STATUS_REQUEST,
    )]: () => false,
  },
  false,
);

export default combineReducers({
  data,
  isLoading,
  error,
  lock,
  lockingErrorType,
  partners,
  userStatuses,
  taskLists,
  visitTypes,
  isSaving,
  saveSuccess,
  lockingErrors,
  connectionStatus,
  connectionStatusLoading,
  connectionStatusError,
});
